export default __webpack_public_path__ + "static/media/bg.bf8c1f64.jpg";